<!-- eslint-disable -->
<template lang="pug">
    .form
        .form__container
            .form__title
                | {{ pageTitle }}
            form.form__body(
                action="javascript://"
                @submit="submitForm"
                v-if='!isLoading'
            )
                .form__field
                    label.form__label
                        | {{ $i18n.t('presentations.presentations_form_name') }}
                    .form__field-body
                        cs-input(
                            :erorr="errors.has('name')",
                            type='text',
                            v-model='presentation.name',
                            name='name',
                            v-validate="'required'",
                            :data-vv-as="$i18n.t('presentations.presentations_form_name').toLowerCase()",
                            :disabled='isEducationMaterial && !user.isSuperadmin && !user.isManagerOrSupport'
                        )
                        help-text(v-if="errors.has('name')", error)
                            | {{ errors.first('name') }}
                .form__field
                    label.form__label
                        | {{ $i18n.t('presentations.presentations_form_type') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='false',
                            :options='types',
                            :show-labels='false',
                            :allow-empty='false',
                            track-by='name',
                            label='name',
                            :placeholder="$i18n.t('presentations.presentations_form_choosePresentationType')",
                            v-model='selectedType',
                            :disabled='isEducationMaterial && !user.isSuperadmin && !user.isManagerOrSupport'
                        )

                .form__field(v-if="selectedType.type === 'google' || selectedType.type === 'slides'")
                    label.form__label
                        | {{ $i18n.t('presentations.presentations_form_url') }}
                    .form__field-body
                        cs-input(
                            :erorr="errors.has('url')",
                            type='text',
                            v-model='presentation.url',
                            name='url',
                            v-validate="'required'",
                            :data-vv-as="$i18n.t('presentations.presentations_form_url').toLowerCase()",
                            :disabled='isEducationMaterial && !user.isSuperadmin && !user.isManagerOrSupport'
                        )
                        help-text(v-if="errors.has('url')", error)
                            | {{ errors.first('url') }}
                .form__field(v-else="")
                    label.form__label
                        | {{ $i18n.t('presentations.presentations_form_file') }}
                    .form__field-body
                        .attachment-files(v-if='file')
                            .attachment
                                | {{ file.name }}
                                a.delete-file(href='javascript://', @click='deleteFile')
                                    svg-icon(name="cancel", size="x-large")
                        template(v-if="!file")
                            label.label-button(for='file-select')
                                svg-icon.label-button__icon(name="paperclip", height="16px", width="16px")
                                span
                                    | {{ $i18n.t('conversations.conversations_conversation_attachFiles') }}
                                input#file-select(type='file', ref='fileSelect', @change.stop='setFile')
                            help-text(error)
                                | {{ $i18n.t('presentations.presentations_fileError') }}
                .form__field
                    label.form__label
                        | {{ $i18n.t('presentations.presentations_form_themes') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='true',
                            :options='themes',
                            :show-labels='false',
                            :allow-empty='true',
                            :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                            label='name',
                            track-by='id',
                            :searchable='true',
                            :loading='loadingThemes',
                            @open='getThemes',
                            v-model='presentation.themes',
                            v-validate="isEducationMaterial ? 'required' : ''",
                            data-vv-value-path='innerValue',
                            data-vv-name='themes',
                            :data-vv-as="$i18n.t('presentations.presentations_form_themes')",
                            :disabled='loadingThemes || (isEducationMaterial && !user.isSuperadmin && !user.isManagerOrSupport)'
                        )
                            span(slot='noResult')
                                | {{ $i18n.t('presentations.presentations_form_themesNotFound') }}
                        help-text(v-if="errors.has('themes')", error)
                            | {{ errors.first('themes') }}
                .form__field(v-if='isVisibleOnlyToMeOptionAvailable')
                    label.form__label
                        | {{ $i18n.t('presentations.presentations_form_visibleOnlyToMe') }}
                    .form__field-body
                        cs-checkbox(v-model='presentation.visibleOnlyToMe')
                .form__field(v-if='user.isSuperadmin || user.isManagerOrSupport || !this.isEducationMaterial')
                    label.form__label
                        | {{ $i18n.t('homework.homework_create_school') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='true',
                            :options='schools',
                            :show-labels='false',
                            :allow-empty='!!user.isSuperadmin || !!user.isManagerOrSupport',
                            :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                            label='name',
                            track-by='id',
                            :searchable='true',
                            :loading='loadingSchools',
                            @open='getSchools',
                            v-model='presentation.schools',
                            :v-validate='validationRules',
                            data-vv-value-path='innerValue',
                            data-vv-name='school',
                            :data-vv-as="$i18n.t('homework.homework_create_schoolVvSs')",
                            :disabled='loadingSchools || presentation.visibleOnlyToMe'
                        )
                            span(slot='noResult')
                                | {{ $i18n.t('homework.homework_create_schoolNotFound') }}
                        help-text(v-if="errors.has('school')", error)
                            | {{ errors.first('school') }}
                .form__field(v-if='user.isSuperadmin || user.isManagerOrSupport')
                    label.form__label
                    .form__field-body
                        help-text(slot='help-text', v-text=" $i18n.t('billing.billing_stocks_schoolsHelper')")
                .form__field(v-if="user.type === 'admin' && !user.isSuperadmin && isEducationMaterial")
                    label.form__label
                        | {{ $i18n.t('homework.homework_create_grade') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='true',
                            :close-on-select='false',
                            :options='grades',
                            :show-labels='false',
                            :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                            label='name',
                            track-by='id',
                            :searchable='true',
                            :loading='loadingGrades',
                            @open='getGrades',
                            v-model='presentation.grades',
                            :v-validate='validationRules',
                            data-vv-value-path='innerValue',
                            data-vv-name='grade',
                            :data-vv-as="$i18n.t('homework.homework_create_gradeVvSs')",
                            :disabled='loadingGrades || presentation.visibleOnlyToMe'
                        )
                            span(slot='noResult')
                                | {{ $i18n.t('homework.homework_create_gradeNotFound') }}
                        help-text(v-if="errors.has('grade')", error)
                            | {{ errors.first('grade') }}
                .form__field(v-if="user.type === 'admin' && !user.isSuperadmin && isEducationMaterial")
                    label.form__label
                    .form__field-body
                        help-text(slot='help-text', v-text=" $i18n.t('presentations.presentations_form_gradesHelper')")
                .form__buttons
                    cs-button.form__button(
                        color="blue"
                        type="submit"
                        :loading="isLoading"
                    )
                        | {{ $i18n.t('homework.homework_create_save') }}
                    cs-button.form__button(
                        color="blue"
                        pattern="primary-outline"
                        @click.prevent="$router.back()"
                    )
                        | {{ $i18n.t('common.common_button_cancel') }}
            cs-loader(v-else='')

</template>

<script>
    /*eslint-disable*/
    import { cloneDeep } from "lodash";
    import PresentationApi from "../../api/games/presentationsApi";
    import { mapState } from "vuex";
    import SchoolApi from "../../api/school";
    import PresentationsThemesApi from "../../api/games/presentationThemeApi";
    import GradeApi from '../../api/grade'

    const SUPPORTED_FORMATS = ['pdf', 'pptx', 'ppt', 'PDF', 'PPTX', 'PPT'];
    const MAX_SIZE = 50;

    export default {
        props: {
            copy: {
                type: Object,
                default: null,
            },
            type: {
                type: String,
                default: 'presentations',
            },
            page: {
                type: [String, Number],
            },
            id: {
                type: [Number, String],
            }
        },
        mounted () {
            this.fetchData();
        },
        data () {
            return {
                presentation: {
                    name: '',
                    url: '',
                    schools: [],
                    grades: [],
                    themes: [],
                    visibleOnlyToMe: false
                },
                isLoading: false,
                loadingSchools: false,
                loadingGrades: false,
                schools: [],
                grades: [],
                loadingThemes: false,
                themes: [],
                types: [
                    {name: this.$i18n.t('presentations.presentations_types_google'), type: 'google'},
                    {name: this.$i18n.t('presentations.presentations_types_slides'), type: 'slides'},
                    {name: this.$i18n.t('presentations.presentations_types_file'), type: 'file'},
                ],
                selectedType: {name: this.$i18n.t('presentations.presentations_types_slides'), type: 'slides'},
                file: null,
                fileWasChanged: false,
            }
        },
        watch: {
            selectedType (value) {
                if (value.type !== 'file') {
                    this.file = null;
                    this.fileWasChanged = false;
                }
            },
            'presentation.visibleOnlyToMe': {
                handler (val) {
                    if (val) {
                        this.isCreator && (this.presentation.schools = []);
                        this.presentation.grades = []
                    }
                }
            }
        },
        methods: {
            fetchData () {
                this.isEducationMaterial && !this.user.isSuperadmin && !this.user.isManagerOrSupport
                        ? this.getGrades()
                        : this.getSchools();
                if (this.copy) {
                    this.presentation = cloneDeep(this.copy);
                    if (!this.isEducationMaterial || this.user.isSuperadmin || this.user.isManagerOrSupport) {
                        this.$set(this.presentation, 'visibleOnlyToMe', this.presentation.usersFilterType === 'only_creator');
                    } else {
                        this.$set(this.presentation, 'visibleOnlyToMe', !this.presentation.grades.some(grade => this.user.schoolsIds.includes(grade.schoolId)));
                    }
                    if (this.isEducationMaterial) {
                        this.presentation.grades = this.presentation.grades.filter(grade => this.user.schoolsIds.includes(grade.schoolId));
                    }
                    this.selectedType = this.types.find(element => element.type === this.presentation.type);
                    if (this.selectedType.type === 'file') {
                        this.file = {
                            name: this.presentation.url.split('/')[this.presentation.url.split('/').length - 1],
                            size: 1,
                        }
                    }
                } else if (this.id) {
                    PresentationApi.show(this.id)
                    .then(data => {
                        this.presentation = data.presentation;
                        if (!this.isEducationMaterial || this.user.isSuperadmin || this.user.isManagerOrSupport) {
                          this.$set(this.presentation, 'visibleOnlyToMe', this.presentation.usersFilterType === 'only_creator');
                        } else {
                          this.$set(this.presentation, 'visibleOnlyToMe', !this.presentation.grades.some(grade => this.user.schoolsIds.includes(grade.schoolId)));
                        }
                        if (this.isEducationMaterial) {
                            this.presentation.grades = this.presentation.grades.filter(grade => this.user.schoolsIds.includes(grade.schoolId));
                        }
                        this.presentation.grades = this.presentation.grades.filter(grade => this.user.schoolsIds.includes(grade.schoolId));
                        this.selectedType = this.types.find(element => element.type === this.presentation.type);
                        if (this.selectedType.type === 'file') {
                            this.file = {
                                name: this.presentation.url.split('/')[this.presentation.url.split('/').length - 1],
                                size: 1,
                            }
                        }
                    })
                    .catch(err => {
                        this.showErrorMessage(err)
                    })
                }
            },
            getThemes() {
                if (this.themes.length) {
                    return;
                }
                this.loadingThemes = true;
                PresentationsThemesApi.list({
                    all: true,
                    isEducationMaterial: this.isEducationMaterial
                }).then(data => {
                    let themes = data.themes;
                    this.themes = themes ? themes : [];
                    this.loadingThemes = false;
                }).catch(() => {
                    this.loadingThemes = false;
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                });
            },
            getSchools() {
                if (this.schools.length) {
                    return;
                }
                this.loadingSchools = true;
                SchoolApi.list({
                    all: true,
                    withActiveAccount: !this.isEducationMaterial,
                }).then(data => {
                    let schools = data.schools;
                    this.schools = schools ? schools : [];
                    this.loadingSchools = false;
                }).catch(() => {
                    this.loadingSchools = false;
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                });
            },
            getGrades() {
                if (this.grades.length) {
                    return;
                }
                this.loadingGrades = true;
                GradeApi.list({
                    schoolsIds: _.intersectionBy(this.user.schools, this.presentation.schools || [], 'id'),
                    all: true,
                    status: 'active',
                }).then(data => {
                    let grades = data.grades;
                    this.grades = grades ? grades : [];
                    this.loadingGrades = false;
                }).catch(err => {
                    this.loadingGrades = false;
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                });
            },
            showErrorMessage (err) {
                this.isLoading = false;
                if (err.data) {
                    let location = this.isEducationMaterial
                            ? { name: 'education-materials:main' }
                            : { name: 'create:game', query: {slug: 'Presentations'} }
                    this.$router.push( location);
                    this.$toasted.error(err.message);
                }
                err = (err.response && err.response.data) ? err.response.data : err;
                if (err && (err.status_code === 403 || err.status_code === 404)) {
                    this.$router.push({ name: 'dashboard' });
                    this.$toasted.error(err.message);
                }
            },
            submitForm () {
                this.$validator.validateAll()
                .then((isValid) => {
                    if (isValid) {
                        if (this.selectedType.type === 'google' && !this.presentation.url.includes('https://docs.google.com/presentation') ||
                            this.selectedType.type === 'slides' && !this.presentation.url.includes('https://slides.com/cleverstart')
                        ) {
                            this.selectedType.type === 'google' ? this.$toasted.info(this.$i18n.t('presentations.presentations_onlyGoogleDocsAvailable'), {duration: 5000}) :
                                this.$toasted.info(this.$i18n.t('presentations.presentations_onlySlidesAvailable'), {duration: 5000});
                            return;
                        }
                        if (this.selectedType.type === 'file') {
                            let formats = new RegExp(SUPPORTED_FORMATS.join('|'));
                            if (!this.file) {
                                this.$toasted.error(this.$i18n.t('presentations.presentations_fileError'), {duration: 5000});
                                return;
                            }
                            if (!formats.test(/[^.]+$/.exec(this.file.name)[0]) || this.file.size > MAX_SIZE * 1000000) {
                                this.$toasted.error(this.$i18n.t('presentations.presentations_filesExtensionOrSizeError', {maxSize: MAX_SIZE}), {duration: 5000});
                                return;
                            }
                        }
                        this.presentation.schoolsIds = this.presentation.schools.map(school => school.id);
                        this.presentation.themesIds = this.presentation.themes.map(theme => theme.id);
                        this.isLoading = true;
                        let formData = new FormData();
                        formData.append('name', this.presentation.name);
                        formData.append('type', this.selectedType.type);
                        formData.append('visible_only_to_me', +this.presentation.visibleOnlyToMe);
                        formData.append('is_education_material', +this.isEducationMaterial);
                        formData.append('file_was_changed', this.fileWasChanged);
                        if (this.fileWasChanged) {
                            formData.append('file', this.file);
                        }
                        formData.append('url', this.presentation.url);
                        this.presentation.schoolsIds.forEach((element, index) => {
                            formData.append(`schools_ids[${index}]`, element);
                        });
                        this.presentation.themesIds.forEach((element, index) => {
                            formData.append(`themes_ids[${index}]`, element);
                        });
                        if (this.isEducationMaterial && !this.user.isSuperadmin && !this.user.isManagerOrSupport) {
                            if (this.presentation.grades.length) {
                                this.presentation.gradesIds = this.presentation.grades.map(grade => grade.id);
                            } else if (!this.presentation.visibleOnlyToMe) {
                                this.presentation.gradesIds = this.grades.map(grade => grade.id);
                            } else {
                                this.presentation.gradesIds = [];
                            }
                            this.presentation.gradesIds.forEach((element, index) => {
                                formData.append(`grades_ids[${index}]`, element);
                            });
                        }
                        if (this.copy) {
                            delete this.presentation.id;
                            delete this.presentation.updatedAt;
                            delete this.presentation.createdAt;
                        }
                        let params = +this.id ? {id: +this.id, formData} : formData;
                        PresentationApi[+this.id ? 'update' : 'create'](params)
                        .then(() => {
                            let location = this.isEducationMaterial
                                    ? { name: 'education-materials:main' }
                                    : { name: 'create:game', query: {slug: 'Presentations'} }
                            this.$router.push(location);
                        })
                        .catch(err => this.showErrorMessage(err));
                    }
                });
            },
            setFile (e) {
                let file = e.target.files[0] || e.dataTransfer.files[0];
                if (!file) {
                    return;
                }
                this.file = file;
                this.fileWasChanged = true;
                e.target.value = '';
            },
            deleteFile () {
                this.file = null;
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            pageTitle () {
                return !this.id ? this.$i18n.t('presentations.presentations_createTitle') : this.$i18n.t('presentations.presentations_updateTitle');
            },
            validationRules () {
                if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                    return '';
                }
                return 'required';
            },
            isEducationMaterial () {
                if (this.copy) {
                    return !!this.copy.isEducationMaterial;
                }
                return this.type === 'education-material';
            },
            isVisibleOnlyToMeOptionAvailable () {
                return !this.isEducationMaterial ? this.isCreator : this.presentation;
            },
            isCreator () {
                return this.copy ? this.user.id === this.copy.userId : true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form__container {
        margin: 0;
        padding: 30px 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            padding: 30px;
        }
    }

    .form {
        margin: 0;
        height: 100%;
        background-color: $x-color-white;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        @include media($md) {
            padding: 30px;
        }
    }

    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__games {
        margin: 0 0 0 auto;
        width: 100%;
    }

    .form__input {
        margin-bottom: 0;
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            min-width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            width: 13em;
            min-width: 13em;
        }
    }

    .form__label--image {
        @include media($md) {
            padding-top: 2.5em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field-body--bold {
        font-weight: 500;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .attachment-files {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }

    .attachment {
        display: flex;
        align-items: center;
        margin-right: 20px;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        font-size: 16px;
        line-height: 24px;
        margin-top: 10px;
    }

    .delete-file {
        color: $hsl-color-gray-74;
        &:hover {
            color: $hsl-color-red-62;
        }
    }

    .label-button {
        transition: 0.3s;

        font-weight: normal;

        cursor: pointer;
        outline: none;

        display: flex;
        vertical-align: middle;
        text-align: center;
        justify-content: center;
        align-items: center;

        color: $hsl-color-blue-56;
        background-color: transparent;
        border: 1px solid $hsl-color-blue-56;

        border-radius: $border-radius-6;
        box-sizing: border-box;
        padding: 8px 16px;
        font-size: 14px;
        line-height: 17px;

        max-width: 193px;


        margin-bottom: 10px;
        @include media($md) {
            margin-bottom: 0;
        }
    }

    .label-button:hover {
        color: $x-color-white;
        background-color: $hsl-color-blue-48;
    }

    .label-button__icon {
        margin-right: 14px;
    }

    #file-select {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        display: block;
    }
</style>
